
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  onSubmit
}) => {
  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      onSubmit(e);
    }} className="relative">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder="Search techniques..."
        className="pl-9"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </form>
  );
};
